var map = {
	"./BURGER.svg": "fafa",
	"./activity.svg": "43ba",
	"./airplay.svg": "38ab",
	"./alert-circle.svg": "0bff",
	"./alert-octagon.svg": "235e",
	"./alert-triangle.svg": "b042",
	"./align-center.svg": "176b",
	"./align-justify.svg": "4bca",
	"./align-left.svg": "a634",
	"./align-right.svg": "5907",
	"./anchor.svg": "c9e5",
	"./aperture.svg": "300d",
	"./archive.svg": "15ed",
	"./arrow-down-circle.svg": "18c0",
	"./arrow-down-left.svg": "8f05",
	"./arrow-down-right.svg": "b89f",
	"./arrow-down.svg": "4e10",
	"./arrow-left-circle.svg": "70b8",
	"./arrow-left.svg": "29e0",
	"./arrow-right-circle.svg": "9da6",
	"./arrow-right-waterblue.svg": "a489",
	"./arrow-right-white.svg": "e79c",
	"./arrow-right.svg": "4832",
	"./arrow-up-circle.svg": "2673",
	"./arrow-up-left.svg": "88a3",
	"./arrow-up-right.svg": "08d2",
	"./arrow-up-white-thin.svg": "3c34",
	"./arrow-up-white.svg": "79b1",
	"./arrow-up.svg": "54fc",
	"./at-sign.svg": "0c4d",
	"./award.svg": "1d05",
	"./bar-chart-2.svg": "0dae",
	"./bar-chart.svg": "eb0e",
	"./battery-charging.svg": "1bb5",
	"./battery.svg": "c9a8",
	"./bell-off.svg": "12cb",
	"./bell.svg": "bc57",
	"./bluetooth.svg": "60a2",
	"./bold.svg": "44db",
	"./book-open.svg": "e3fb",
	"./book.svg": "ac3b",
	"./bookmark.svg": "8384",
	"./box.svg": "3102",
	"./briefcase.svg": "f18c",
	"./calendar.svg": "55d8",
	"./camera-off.svg": "b2b4",
	"./camera.svg": "eeff",
	"./cast.svg": "b8c6",
	"./check-circle-green.svg": "3b79",
	"./check-circle.svg": "6160",
	"./check-square.svg": "f5a8",
	"./check-white.svg": "4911",
	"./check.svg": "58a7",
	"./chevron-down.svg": "988d",
	"./chevron-left.svg": "b7f6",
	"./chevron-right.svg": "50d6",
	"./chevron-up.svg": "5454",
	"./chevrons-down.svg": "10d3",
	"./chevrons-left.svg": "6671",
	"./chevrons-right.svg": "9c81",
	"./chevrons-up.svg": "9ceb",
	"./chrome.svg": "ef0d",
	"./circle.svg": "b612",
	"./clipboard.svg": "643a",
	"./clock.svg": "715e",
	"./cloud-drizzle.svg": "59fb",
	"./cloud-lightning.svg": "88a8",
	"./cloud-off.svg": "4478",
	"./cloud-rain.svg": "35a1",
	"./cloud-snow.svg": "6d98",
	"./cloud.svg": "50cc",
	"./code.svg": "813d",
	"./codepen.svg": "003d",
	"./codesandbox.svg": "5196",
	"./coffee.svg": "b102",
	"./columns.svg": "7c2d",
	"./command.svg": "6208",
	"./compass.svg": "3fee",
	"./copy.svg": "7c80",
	"./corner-down-left.svg": "17df",
	"./corner-down-right.svg": "0028",
	"./corner-left-down.svg": "d114",
	"./corner-left-up.svg": "ccfb",
	"./corner-right-down.svg": "0457",
	"./corner-right-up.svg": "6553",
	"./corner-up-left.svg": "90e2",
	"./corner-up-right.svg": "7221",
	"./cpu.svg": "c4be",
	"./credit-card.svg": "2909",
	"./crop.svg": "adc8",
	"./crosshair.svg": "c5b9",
	"./database.svg": "998b",
	"./delete.svg": "9e73",
	"./disc.svg": "2c19",
	"./dollar-sign.svg": "096e",
	"./download-cloud.svg": "95c9",
	"./download.svg": "baa7",
	"./droplet.svg": "0a5b",
	"./edit-2.svg": "8478",
	"./edit-3.svg": "67c9",
	"./edit.svg": "2384",
	"./external-link.svg": "ffb1",
	"./eye-off.svg": "85c1",
	"./eye.svg": "f861",
	"./facebook-white.svg": "c28b",
	"./facebook.svg": "9151",
	"./fast-forward.svg": "a67c",
	"./feather.svg": "39b1",
	"./figma.svg": "a0d7",
	"./file-minus.svg": "45e9",
	"./file-plus.svg": "6e25",
	"./file-text.svg": "427c",
	"./file.svg": "7bbe",
	"./film.svg": "61f7",
	"./filter.svg": "84e8",
	"./flag.svg": "1631",
	"./folder-minus.svg": "d491",
	"./folder-plus.svg": "4e0e",
	"./folder.svg": "459b",
	"./framer.svg": "f87f",
	"./frown.svg": "a5d5",
	"./gift.svg": "839e",
	"./git-branch.svg": "4f2f",
	"./git-commit.svg": "b874",
	"./git-merge.svg": "d8a8",
	"./git-pull-request.svg": "77c9",
	"./github.svg": "5f94",
	"./gitlab.svg": "3550",
	"./globe.svg": "66b2",
	"./grid.svg": "d3f2",
	"./hard-drive.svg": "8808",
	"./hash.svg": "6071",
	"./headphones.svg": "b222",
	"./heart-waterblue.svg": "03cc",
	"./heart-white-full.svg": "daa6",
	"./heart-white.svg": "9b14",
	"./heart.svg": "8afc",
	"./help-circle.svg": "b87b",
	"./hexagon.svg": "2490",
	"./home.svg": "5e7c",
	"./image.svg": "886c",
	"./inbox.svg": "016e",
	"./info.svg": "3561",
	"./instagram.svg": "fe65",
	"./italic.svg": "8c62",
	"./key.svg": "12c1",
	"./layers.svg": "f721",
	"./layout.svg": "f787",
	"./life-buoy.svg": "cc26",
	"./link-2.svg": "ecfb",
	"./link.svg": "4524",
	"./linkedin-white.svg": "2255",
	"./linkedin.svg": "62da",
	"./list.svg": "6064",
	"./loader.svg": "52cf",
	"./lock.svg": "25e0",
	"./log-in.svg": "d0cb",
	"./log-out.svg": "423f",
	"./mail.svg": "c241",
	"./map-pin.svg": "1c1d",
	"./map.svg": "095a",
	"./maximize-2.svg": "5463",
	"./maximize.svg": "49f0",
	"./meh.svg": "c8fb",
	"./menu.svg": "ba30",
	"./message-circle.svg": "790f",
	"./message-square.svg": "b5e8",
	"./mic-off.svg": "06aa",
	"./mic.svg": "8209",
	"./minimize-2.svg": "5a30",
	"./minimize.svg": "2fe1",
	"./minus-circle.svg": "5ac3",
	"./minus-square.svg": "ac2c",
	"./minus.svg": "4fda",
	"./monitor.svg": "680d",
	"./moon.svg": "1759",
	"./more-horizontal.svg": "20f5",
	"./more-vertical.svg": "4f8e",
	"./mouse-pointer.svg": "f940",
	"./move.svg": "141e",
	"./music.svg": "fd00",
	"./navigation-2.svg": "986b",
	"./navigation.svg": "b841",
	"./octagon.svg": "6f5b",
	"./package.svg": "6a6a",
	"./paperclip.svg": "04fe",
	"./pause-circle.svg": "92d1",
	"./pause.svg": "58a4",
	"./pen-tool.svg": "1953",
	"./percent.svg": "3654",
	"./phone-call.svg": "f782",
	"./phone-forwarded.svg": "025e",
	"./phone-incoming.svg": "6ef8",
	"./phone-missed.svg": "9bb1",
	"./phone-off.svg": "0582",
	"./phone-outgoing.svg": "513f",
	"./phone.svg": "8322",
	"./pie-chart.svg": "f79d",
	"./play-circle.svg": "92d3",
	"./play.svg": "8f5a",
	"./plus-circle.svg": "1dd5",
	"./plus-square.svg": "fdd3",
	"./plus.svg": "5f2d",
	"./pocket.svg": "69c4",
	"./power.svg": "b5f2",
	"./printer.svg": "9a83",
	"./radio.svg": "23d4",
	"./refresh-ccw.svg": "447d",
	"./refresh-cw.svg": "b038",
	"./repeat.svg": "1905",
	"./rewind.svg": "949a",
	"./rotate-ccw.svg": "0094",
	"./rotate-cw.svg": "b78e",
	"./rss.svg": "4ad7",
	"./save.svg": "d46e",
	"./scissors.svg": "e602",
	"./search.svg": "9601",
	"./send.svg": "749f",
	"./server.svg": "7b15",
	"./settings.svg": "e575",
	"./share-2.svg": "406e",
	"./share.svg": "0cbd",
	"./shield-off.svg": "0a77",
	"./shield.svg": "2b72",
	"./shopping-bag.svg": "71bf",
	"./shopping-cart.svg": "c60f",
	"./shuffle.svg": "c01e",
	"./sidebar.svg": "5f91",
	"./skip-back.svg": "e5c3",
	"./skip-forward.svg": "ae76",
	"./slack.svg": "e450",
	"./slash.svg": "4f81",
	"./sliders.svg": "3a63",
	"./smartphone.svg": "f095",
	"./smile.svg": "d797",
	"./speaker.svg": "d01a",
	"./square.svg": "916d",
	"./star.svg": "a9a4",
	"./stop-circle.svg": "3e15",
	"./sun.svg": "c681",
	"./sunrise.svg": "d161",
	"./sunset.svg": "323d",
	"./tablet.svg": "696d",
	"./tag.svg": "7347",
	"./target.svg": "2087",
	"./terminal.svg": "0e95",
	"./thermometer.svg": "3569",
	"./thumbs-down.svg": "3b29",
	"./thumbs-up.svg": "0935",
	"./toggle-left.svg": "7a9b",
	"./toggle-right.svg": "9f6d",
	"./tool.svg": "7391",
	"./trash-2.svg": "ce50",
	"./trash.svg": "ba3e",
	"./trello.svg": "f803",
	"./trending-down.svg": "17cf",
	"./trending-up.svg": "8c74",
	"./triangle.svg": "9470",
	"./truck.svg": "f5a9",
	"./tv.svg": "0411",
	"./twitch.svg": "d91e",
	"./twitter-white.svg": "d3d4",
	"./twitter.svg": "147b",
	"./type.svg": "02c1",
	"./umbrella.svg": "d62a",
	"./underline.svg": "05b8",
	"./unlock.svg": "5aa2",
	"./upload-cloud.svg": "6640",
	"./upload.svg": "55ae",
	"./user-check.svg": "45ba",
	"./user-minus.svg": "7c8c",
	"./user-plus.svg": "580a",
	"./user-x.svg": "6721",
	"./user.svg": "13bf",
	"./users.svg": "47f8",
	"./video-off.svg": "5b39",
	"./video.svg": "09d2",
	"./voicemail.svg": "e88d",
	"./volume-1.svg": "e551",
	"./volume-2.svg": "6960",
	"./volume-x.svg": "ab4c",
	"./volume.svg": "ac39",
	"./watch.svg": "5a97",
	"./wifi-off.svg": "e604",
	"./wifi.svg": "5afb",
	"./wind.svg": "3a24",
	"./x-circle-red.svg": "b42e",
	"./x-circle.svg": "af3b",
	"./x-octagon.svg": "7948",
	"./x-square.svg": "626b",
	"./x.svg": "9bf0",
	"./youtube.svg": "71ad",
	"./zap-off.svg": "edfb",
	"./zap.svg": "06fc",
	"./zoom-in.svg": "ae17",
	"./zoom-out.svg": "cf4c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6365";